export class LoginUserData {
	public username: string;
	public password: string;
}
